export default __webpack_public_path__ + "static/InHub_FS2S_2023-2-db79f255bbe129449a25b26b4fd2632b.jpg";